import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { avatarService } from '@/services/avatar';

export function useAvatarDefaultList() {
    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            type: { type: 'string', default: '' },
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: avatarService.default.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            transformResponse: list =>
                list.map(avatar => ({
                    ...avatar,
                    canTranslate: avatar.type === 1 || avatar.type === 4 // Bot || FakePlayer
                }))
        }
    });

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: avatarService.default.remove,
            onSuccess: () => fetchList()
        })
    };

    return { query, list, total, fetchList, actions };
}
